import { showToast } from "@certn/cascadia";
import { BasicButton, Stack, TextField } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  label: string;
  testID: string;
  isCopyable?: boolean;
}

export function CopiableValue({
  value,
  label,
  testID,
  isCopyable = true,
}: Props) {
  const { t } = useTranslation();
  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(value);
      showToast(t("Copied to clipboard"), {
        type: "success",
      });
    } catch {
      showToast(t("Unable to copy to clipboard"), {
        type: "error",
      });
    }
  };

  return (
    <Stack orientation="horizontal" align="end" gap="space-2">
      <TextField
        className={styles.textFieldSpacing}
        testID={testID}
        label={label}
        value={value}
        isDisabled
        isRequired
      />
      {isCopyable ? (
        <BasicButton
          onPress={copyToClipBoard}
          type="button"
          size="medium"
          testID={`${testID}-copy-button`}
          leftIcon="link"
          aria-label={t("Copy {{label}}", { label })}
        >
          {t("Copy")}
        </BasicButton>
      ) : null}
    </Stack>
  );
}

const styles = {
  textFieldSpacing: css({
    width: "440px !important",
  }),
};
